import styled, { css } from "styled-components";

export const DayRoot = styled.div<{ selected?: boolean }>(
    ({ theme, selected }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 46px;
        height: 46px;
        background-color: ${selected ? theme.palette.primary : "none"};
        color: ${selected ? "white" : "black"};
        cursor: pointer;
        border-radius: 50%;

        ${!selected &&
        css`
            &:hover {
                background-color: #eee;
            }
        `}
    `,
);
